const vuexHelper = {
    mapState(fields) {
        const result = {};

        fields.forEach(name => {
            result[name] = {
                get() {
                    return this.$store.state[name];
                },

                set(value) {
                    this.$store.commit("set" + name.charAt(0).toUpperCase() + name.slice(1), value);
                }
            };
        });

        return result;
    },

    createSetters(fields) {
        const result = {};

        fields.forEach(name => {
            result["set" + name.charAt(0).toUpperCase() + name.slice(1)] = (state, newValue) => state[name] = newValue;
        });

        return result;
    }
};

export default vuexHelper;